import { render } from "./footerPage.vue?vue&type=template&id=8bb34a96&scoped=true"
import script from "./footerPage.vue?vue&type=script&lang=js"
export * from "./footerPage.vue?vue&type=script&lang=js"

import "./footerPage.vue?vue&type=style&index=0&id=8bb34a96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb34a96"]])

export default __exports__